import { BasketViewModel } from '@models/api-orders.models';
import { ReserveInStore, ReserveProductDetail } from '@features/reserve-in-store/reserve-in-store';

export const mapToReservation = (reservation: BasketViewModel): Partial<ReserveInStore> => ({
    items: reservation.lines as ReserveProductDetail[],
    totalProductsCount: reservation.totalProductsCount || 0,
    totalPrice: reservation.totalPrice,
    vatAmount: reservation.vatAmount,
    vatAmountRaw: reservation.vatAmountRaw,
    totalLinesPrice: reservation.totalLinesPrice,
    totalLinesPriceBeforeDiscount: reservation.totalLinesPriceBeforeDiscount,
    totalLinesPriceBeforeDiscountRaw: reservation.totalLinesPriceBeforeDiscountRaw,
    totalLinesDiscountAmount: reservation.totalLinesDiscountAmount,
    totalLinesDiscountAmountRaw: reservation.totalLinesDiscountAmountRaw || 0
});
